interface HorizontalRadioProps {
  label: string;
  showLabel?: boolean;
  small?: string | null;
  children: React.ReactNode;
}

export default function HorizontalRadio({
  label,
  showLabel,
  small,
  children,
}: HorizontalRadioProps) {
  return (
    <div>
      {showLabel ? (
        <label
          className={`mb-${
            small === null ? 3 : 1
          } block text-left text-sm font-medium text-black`}
        >
          {label}
        </label>
      ) : (
        <label
          className={`mb-${
            small === null ? 3 : 1
          } block text-left text-sm font-medium text-black/`}
        />
      )}
      {small !== null && (
        <p className="text-xs text-left text-secondary italic mb-3">{small}</p>
      )}
      <fieldset className="mt-4">
        <legend className="sr-only">{label}</legend>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
          {children}
        </div>
      </fieldset>
    </div>
  );
}

HorizontalRadio.defaultProps = {
  showLabel: true,
  small: null,
};
